module.exports = {"searchReport":{"title":"Search Report","authorHeader":"Author of Report:","dateHeader":"Date of Search:","hostHeader":"Host name:","summaryHeader":"Summary of Search Strategy:","periodHeader":"Period Searched:","languageHeader":"Language Restrictions:","sourcesUsedLine":"Total of {amount} database used in the search. | Total of {amount} databases used in the search.","databaseLine":"was used via","searchStrategyLine":"Search Strategy (using {dbName} syntax):","shareLinkLine":"Shareable link:"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en-uk/searchReport.json
// module id = FDGF
// module chunks = 1